import { render, staticRenderFns } from "./StaffListU.vue?vue&type=template&id=d66853bc&scoped=true"
import script from "./StaffListU.vue?vue&type=script&lang=js"
export * from "./StaffListU.vue?vue&type=script&lang=js"
import style0 from "./StaffListU.vue?vue&type=style&index=0&id=d66853bc&prod&lang=less"
import style1 from "./StaffListU.vue?vue&type=style&index=1&id=d66853bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66853bc",
  null
  
)

export default component.exports